//Library imports
import { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory, useLocation } from 'react-router-dom';

//Components
import Layout from '../../components/layout';
import DataTable from '../../components/dataTable';
import { billsExported, deleteBillExport } from '../../api/services/quickbooksService'
import { Notification } from '../../components/notifications';
import moment from 'moment';

//Get our view state
type ViewState = {
    message?: string;
};

/**
 * Methods to fetch search criteria with which to populate
 */
const doGetBillsExported = async () => await billsExported();

/**
 * Primary Component
 */
const BillExports = () => {
    //Process our DataTable columns and data
    const columns = () => [
        {
            Header: 'Date and Time Exported',
            accessor: (u: any) => {
                return moment(u.exportedDate).format('MM/DD/YYYY hh:mm');
            },
        },
        {
            Header: 'Start Date',
            accessor: (u: any) => {
                return moment(u.startDate).format('MM/DD/YYYY');
            },
            width: 50
        },
        {
            Header: 'End Date',
            accessor: (u: any) => {
                return moment(u.endDate).format('MM/DD/YYYY');
            },
            width: 50
        },
        {
            Header: 'Status',
            accessor: (u: any) => {
                let status = "";
                let numProcessed = 0;
                for (let b of u.bills) {
                    /*if (r == null)                
                        Possible stata:
                        "": (empty) means the request hasn't been sent to QB yet
                        "Pending"
                        "Processing"
                        "Processed"
                        "Error: <error description>"
                    */
                    if (b.status.substring(0, 6) === "Error:") {
                        status = "Error"; //Any error makes the whole export an error
                        break;
                    } else if (b.status == "Pending") {
                        status = "Pending"; //If there's at least 1 pending, the whole export is pending                                 
                    } else if (b.status == "Processing") {
                        status = "Processing"; //If there's at least 1 processing, the whole export is processing                                 
                    } else if (b.status == "Processed") {
                        numProcessed++;
                    }
                };
                if ((status == "") && (u.bills.length > 0) && u.bills.length == numProcessed) {
                    status = "Processed";
                }
                return status;
            },
            width: 50
        },
        {
            Header: 'Therapists',
            accessor: (u: any) => {
                const therapistList = u.therapists.map((t: any) =>
                    <span key={t.name}>{t.name + ' - ' + t.divisionName},</span>
                );
                return (
                    <div className='flex items-center'>
                        <div className='w-9/12'>
                            {therapistList}
                        </div>
                        <div className='flex items-center'>
                            <button
                                className='mr-3 py-1 px-2'
                                onClick={() => exportSummary(u.billExportId)}
                            >
                                View Details
                            </button>
                            <button
                                className='bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2'
                                onClick={() => removeBillExport(u.billExportId)}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                );
            },
            width: 500
        },

    ];

    //App hooks
    const history = useHistory();
    const { state } = useLocation<ViewState>();
    const [deletePending, setDeletePending] = useState(false);

    //Data hooks
    const [billsExportedData, setBillsExportedData] = useState<[]>([])

    const doGetBillsExportedAsync = useAsync({
        promiseFn: doGetBillsExported,
        onResolve: (exportedBills: any) => {
            setBillsExportedData(exportedBills.data);
        },
    });

    const exportSummary = (id: number) => history.push(`/accounting/bill/exports/details/${id}`);

    const removeBillExport = async (id: number) => {
        if (!id) {
            return Promise.reject('Missing Billing Export Id.');
        }

        try {
            setDeletePending(true);
            await deleteBillExport(Number(id));
        }
        catch (err) {
            return Promise.reject('Failed to Delete Billing Export.');
        }
        finally {
            return window.location.reload();
        }
    };

    return (
        <Layout isLoading={
            doGetBillsExportedAsync.isPending ||
            deletePending
        }>
            <Fragment>
                <Fragment>
                    {state?.message && <Notification>{state?.message}</Notification>}

                    {/* Results Table */}
                    {billsExportedData !== null && billsExportedData !== undefined && (
                        <div className='results-table'>
                            {billsExportedData.length > 0 && (
                                <div className='shadow overflow-hidden border-b border-gray-200 rounded-lg'>
                                    <DataTable
                                        columns={columns()}
                                        data={billsExportedData}
                                        showPagination={billsExportedData.length > 30 ? true : false}
                                        skipFilter={true}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </Fragment>
            </Fragment>
        </Layout>
    );
};
export default BillExports;
